var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "@inertiajs/react";
export default function ValidationNote(props) {
    var _a = props.note, note = _a === void 0 ? null : _a, _b = props.className, className = _b === void 0 ? null : _b;
    var classes = "text-sm border-l-2 px-4 py-3";
    var map = {
        'error': 'bg-red-200 border-red-400 text-red-700',
        'success': 'bg-green-200 border-green-400 text-green-800',
        'warn': 'bg-yellow-100 border-yellow-400 text-yellow-800',
        'default': 'bg-blue-50 border-blue-400 text-blue-800',
    };
    if (!note) {
        return _jsx(_Fragment, {});
    }
    var showLink = props.showLink === false ? false : true;
    return _jsxs("div", __assign({ "data-validation": note.type, "data-field": props.field, className: "".concat(classes, " ").concat((map[note.type] || map['default']), " ").concat((className)) }, { children: [_jsx("div", __assign({ className: "inline" }, { children: note.message })), note.url && showLink && window.location.href !== note.url && _jsx(Link, __assign({ href: note.url, className: "inline-block text-xs bg-red-300 hover:bg-red-100 uppercase py-1 px-2 rounded ml-2" }, { children: "Fix" }))] }));
}
